import { ArrowRight } from '@/legacy/components/ui/Icons';

const CatalogCta = ({ label }: { label: string }) => (
	<div className='flex items-center gap-2 text-primary-light'>
		<span>{label}</span>
		<ArrowRight />
	</div>
);

export default CatalogCta;
